import { RouteGroup, RouteInfo } from '@farm-portal/core/layout/sidebar/sidebar.metadata';

export class VisibleInDevelopmentHelper {
  private static readonly visibleApiUrlPrefixes = ['https://dev', 'https://localhost'];

  public static shouldShow(hideInProduction?: boolean, apiUrl?: string | null): boolean {
    if (hideInProduction !== true) {
      return true;
    }

    const normalizedApiUrl = (apiUrl ?? '').trim().toLowerCase();
    if (normalizedApiUrl.length === 0) {
      return false;
    }

    return this.visibleApiUrlPrefixes.some(prefix => normalizedApiUrl.startsWith(prefix));
  }

  public static filterRoutes(routes: RouteGroup[], apiUrl?: string | null): RouteGroup[] {
    return routes.map(group => this.filterGroup(group, apiUrl)).filter((group): group is RouteGroup => group !== null);
  }

  private static filterGroup(group: RouteGroup, apiUrl?: string | null): RouteGroup | null {
    if (!this.shouldShow(group.hideInProduction, apiUrl)) {
      return null;
    }

    return {
      ...group,
      routeGroup: group.routeGroup
        .map(routeInfo => this.filterRoute(routeInfo, apiUrl))
        .filter((routeInfo): routeInfo is RouteInfo => routeInfo !== null)
    };
  }

  private static filterRoute(routeInfo: RouteInfo, apiUrl?: string | null): RouteInfo | null {
    if (!this.shouldShow(routeInfo.hideInProduction, apiUrl)) {
      return null;
    }

    return {
      ...routeInfo,
      submenu: routeInfo.submenu
        .map(submenu => this.filterRoute(submenu, apiUrl))
        .filter((submenu): submenu is RouteInfo => submenu !== null)
    };
  }
}
